

































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class NavigationFooter extends Vue {
	@Prop({ default: false })
	private disableNextButton!: boolean
	@Prop({ default: false })
	private isNoWayBack!: boolean

	private get isInvisible (): boolean {
		const path: string = this.$router.currentRoute.path
		// Navigation is invisible on Checkout page (step7) and for all non stepX related pages
		return path.indexOf('/step7') === 0 || path.indexOf('/step') === -1
	}

	private get isReturnScreen (): boolean {
		const path: string = this.$router.currentRoute.path
		return path.indexOf('/step4') === 0
	}
}
